import { load } from './load';

export default load({
  "A": "А",
  "B": "Б",
  "C": "Ц",
  "Ce": "Це",
  "Ch": "Х",
  "Che": "Хе",
  "Chie": "Хе",
  "Ci": "Ти",
  "Cia": "Тꙗ",
  "Cie": "Те",
  "Cio": "ТЁ",
  "Ciu": "Тю",
  "Cią": "Тѭ",
  "Cię": "Тѩ",
  "Cz": "Ч",
  "Cze": "Че",
  "D": "Д",
  "DZ": "Ѕ",
  "Di": "Ді",
  "Dzi": "Ди",
  "Dzia": "Дꙗ",
  "Dzie": "Де",
  "Dzio": "Дё",
  "Dziu": "Дю",
  "Dzią": "Дѭ",
  "Dzię": "Дѩ",
  "DŹ": "Дь",
  "E": "Э",
  "F": "Ф",
  "G": "Ґ",
  "H": "Г",
  "He": "Ге",
  "Hie": "Ге",
  "I": "И",
  "Ia": "Иа",
  "Ie": "Е",
  "Io": "Ио",
  "Iu": "Ю",
  "Iy": "Иы",
  "Ią": "Иѭ",
  "Ię": "Иѩ",
  "J": "Й",
  "Ja": "Ꙗ",
  "Je": "Е",
  "Jo": "Ё",
  "Ju": "Ю",
  "Jy": "Йы",
  "Ją": "Ѭ",
  "Ję": "Ѩ",
  "K": "К",
  "L": "Ль",
  "La": "Лꙗ",
  "Le": "Ле",
  "Li": "Ли",
  "Lo": "Лё",
  "Lu": "Лю",
  "Ló": "Лё̄",
  "Lą": "Лѭ",
  "Lę": "Лѩ",
  "M": "М",
  "N": "Н",
  "O": "О",
  "P": "П",
  "R": "Р",
  "Ri": "Рі",
  "Rz": "Р",
  "Rza": "Рꙗ",
  "Rze": "Ре",
  "Rzo": "Рё",
  "Rzu": "Рю",
  "Rzy": "Ри",
  "Rzą": "Рѭ",
  "Rzę": "Рѩ",
  "S": "С",
  "Sz": "Ш",
  "Sze": "Ше",
  "T": "Т",
  "Ti": "Ті",
  "U": "У",
  "W": "В",
  "Y": "Ы",
  "Yj": "Ый",
  "Z": "З",
  "a": "а",
  "b": "б",
  "c": "ц",
  "ce": "це",
  "ch": "х",
  "che": "хе",
  "chie": "хе",
  "ci": "ти",
  "cia": "тꙗ",
  "cie": "те",
  "cio": "тё",
  "ciu": "тю",
  "cią": "тѭ",
  "cię": "тѩ",
  "cz": "ч",
  "cze": "че",
  "d": "д",
  "di": "ді",
  "diu": "діу",
  "dią": "діѫ",
  "dię": "діѧ",
  "diа": "діа",
  "diе": "діе",
  "diо": "діо",
  "diј": "дій",
  "dz": "ѕ",
  "dzi": "ди",
  "dzia": "дꙗ",
  "dzie": "де",
  "dzio": "дё",
  "dziu": "дю",
  "dzią": "дѭ",
  "dzię": "дѩ",
  "dź": "дь",
  "e": "э",
  "f": "ф",
  "g": "ґ",
  "h": "г",
  "he": "ге",
  "hie": "ге",
  "i": "и",
  "ia": "ꙗ",
  "ie": "е",
  "io": "ё",
  "iu": "ю",
  "iy": "йы",
  "ią": "ѭ",
  "ię": "ѩ",
  "j": "й",
  "ja": "ꙗ",
  "je": "е",
  "jo": "ё",
  "ju": "ю",
  "jy": "йы",
  "ją": "ѭ",
  "ję": "ѩ",
  "k": "к",
  "l": "ль",
  "la": "лꙗ",
  "le": "ле",
  "li": "ли",
  "lo": "лю",
  "lu": "лю",
  "ló": "лё̄",
  "lą": "лѭ",
  "lę": "лѩ",
  "m": "м",
  "n": "н",
  "o": "о",
  "p": "п",
  "r": "р",
  "ri": "рі",
  "riu": "ріу",
  "rią": "ріѫ",
  "rię": "ріѧ",
  "riа": "ріа",
  "riе": "ріе",
  "riо": "ріо",
  "riј": "рій",
  "rz": "р",
  "rza": "рꙗ",
  "rze": "ре",
  "rzo": "рё",
  "rzu": "рю",
  "rzy": "ри",
  "rzą": "рѭ",
  "rzę": "рѩ",
  "s": "с",
  "sz": "ш",
  "sze": "ше",
  "t": "т",
  "ti": "ті",
  "tiu": "тіу",
  "tią": "тіѫ",
  "tię": "тіѧ",
  "tiа": "тіа",
  "tiе": "тіе",
  "tiо": "тіо",
  "tiј": "тій",
  "u": "у",
  "w": "в",
  "y": "ы",
  "yj": "ый",
  "z": "з",
  "Ó": "О̄",
  "ó": "о̄",
  "Ą": "Ѫ",
  "ą": "ѫ",
  "Ć": "Ть",
  "ć": "ть",
  "Ę": "Ѧ",
  "ę": "ѧ",
  "Ł": "Л",
  "ł": "л",
  "Ń": "Нь",
  "ń": "нь",
  "Ś": "Сь",
  "ś": "сь",
  "Ź": "Зь",
  "ź": "зь",
  "Ż": "Ж",
  "Że": "Же",
  "ż": "ж",
  "że": "же",
});

